import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ComingSoon from "@/pages/ComingSoon";
import Welcome from "@/pages/Welcome";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Benchmark from "@/pages/Benchmark";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Feed from "@/pages/Feed";
import UserDashboard from "@/pages/UserDashboard";
import LegalPage from "@/pages/LegalPage";
import CFOStack from "@/pages/CFOStack";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/benchmark" element={<Benchmark />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/cfo-stack" element={<CFOStack />} />
          <Route path="/case-study/:id" element={<CaseStudyDetail />} />
          <Route path="/terms" element={<LegalPage slug="terms" />} />
          <Route path="/privacy" element={<LegalPage slug="privacy" />} />
          <Route path="/cookies" element={<LegalPage slug="cookies" />} />
          <Route path="/about" element={<LegalPage slug="about" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid #e4e4e7",
            color: "#0a0a0a",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
